/**
 * Fold text to something worth comparing a search term against.
 *
 * Latvian carries diacritics that are tedious to type and routinely dropped,
 * so `rezervet` has to find `rezervēt`. NFD splits a letter from its accent
 * and the range strip removes the accent, which is enough for both languages
 * here without pulling in a transliteration library.
 */
export const normalizeForSearch = (value: string | null | undefined): string =>
  (value ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLocaleLowerCase().trim();

export default normalizeForSearch;
